import Requirements from './Requirements'

export default Requirements
